import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';
import withHooks from 'cityads-v3/decorators/withHooks'
import { useCouponFiltersContext } from './CouponFilters.hooks'

import Button from '@mui/material/Button'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField';

import CopyTextField from 'cityads-v3/components/CopyTextField/CopyTextField';
import Dialog from 'cityads-v3/components/Dialog/Dialog';
import ExportPopupFooter from './ExportPopupFooter';
import Subaccounts from 'cityads-v3/components/Forms/Subaccounts'

import {
  loadCouponFeedLink,
} from 'cityads-v3/actions/offers';

import classNames from './ExportPopup.scss';

@withHooks(props => {
  const filterContext = useCouponFiltersContext()
  const filters = filterContext.selectedFilters.getFormData()
  if (!filters.is_exclusive) { delete filters.is_exclusive }
  if (!filters.is_personal) { delete filters.is_personal }

  return {
    ...props,
    selectedFilters: filters
  }
})
@connect(
  state => ({
    couponFeedLink: state.offers.couponFeedLink,
    couponFeedId: state.offers.couponFeedId,
    isMobile: state.app.isMobile,
  })
)
@withTranslation(['Offers'], { i18n, wait: !!window })
export default class ExportPopup extends Component {

  static propTypes = {
    t: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    open: PropTypes.bool,
    selectedFilters: PropTypes.object,
    couponFeedLink: PropTypes.string,
    couponFeedId: PropTypes.number,
    exportPopupType: PropTypes.string,
    channels: PropTypes.array,
    selectedChannel: PropTypes.number,
    onSubaccountChange: PropTypes.func,
    subaccounts: PropTypes.arrayOf(PropTypes.string),
    showMore: PropTypes.bool,
    isMobile: PropTypes.bool,
  };

  static defaultProps = {
    showMore: true
  };

  state = {
    subaccounts: [''],
    showSas: 1,
    channel: undefined,
  }

  isContentDefault(props = this.props) {
    return Children.count(props.children) === 0;
  }

  componentDidMount() {
    const { dispatch, open } = this.props;

    if (open && this.isContentDefault()) {
      dispatch(loadCouponFeedLink({
        filter: {
          ...this.getFilters()
        }
      }));
    }
  }

  componentDidUpdate(prevProps) {
    const { dispatch, open, selectedChannel } = this.props;

    if (this.state.channel !== selectedChannel) {
      this.setState({
        channel: selectedChannel
      });
    }

    if (open && prevProps.open !== open && this.isContentDefault(this.props)) {
      dispatch(loadCouponFeedLink({
        filter: {
          ...this.getFilters(this.props)
        }
      }));
    }
  }

  getFilters(props = this.props) {
    const { coupon_offer, ...otherFilters } = props.selectedFilters;

    return {
      offers: coupon_offer,
      ...otherFilters,
    };
  }

  saveSA = () => {
    if (!this.isContentDefault()) {
      return;
    }

    const { dispatch, couponFeedId } = this.props;
    const filters = this.getFilters();

    dispatch(loadCouponFeedLink({
      filter: {
        ...filters
      },
      method: 'PATCH',
      subaccount1: this.state.subaccounts[0],
      subaccount2: this.state.subaccounts[1],
      subaccount3: this.state.subaccounts[2],
      subaccount4: this.state.subaccounts[3],
      subaccount5: this.state.subaccounts[4],
    }, couponFeedId));
  }

  getLink() {
    let link = this.props.couponFeedLink;

    if (this.props.exportPopupType !== 'xml') {
      link = link.replace('/xml', '/' + this.props.exportPopupType);
    }

    return link;
  }

  copyCode = () => {
    const elem = this.copy;
    elem.select();
    document.execCommand('copy');
  }

  onChannelChange(evt) {
    const id = evt.target.value;
    this.setState({
      channel: id
    });

    this.props.onChannelChange(id);
  }

  renderChannels() {
    const { channels = [], t } = this.props;
    if (!channels || channels.length < 2) return;

    return (
      <TextField
        select
        label={t('exports.channel')}
        fullWidth = {true}
        onChange  = {(evt) => this.onChannelChange(evt)}
        value={this.state.channel || ''}
      >
        {channels.map(channel => (
          <MenuItem
            key={channel.id}
            value={channel.id}
          >
            {channel.name}
          </MenuItem>
        ))}
      </TextField>
    );
  }

  renderDefaultLinkArea() {
    const { t } = this.props;
    return (
      <div>
        <CopyTextField
          label={t('exports.feedLink')}
          value={this.getLink()}
          multiline={true}
          fullWidth={true}
          inputProps={{ref: copy => this.copy = copy}}
        />

        <div className={classNames.copyButton}>
          <Button
            variant="contained"
            onClick={this.copyCode}
            color="primary"
          >{t('exports.copy')}</Button>
        </div>
      </div>
    );
  }

  handleChangeSubaccounts(value) {
    this.props.onSubaccountChange?.(value)
    this.setState({
      subaccounts: value
    })
  }

  render() {
    const {
      t,
      tReady,
      i18n,
      i18nLoadedAt,
      dispatch,
      children,
      open,
      showMore,
      exportPopupType,
      selectedFilters,
      couponFeedLink,
      couponFeedId,
      subaccounts,
      onSubaccountChange,
      channels,
      selectedChannel,
      onChannelChange,
      isMobile,
      ...rest
    } = this.props;

    return(
      <Dialog
        title             = {t('exports.modalTitle')}
        open              = {open}
        showLogo          = {false}
        childrenClassName = {classNames.content}
        fullScreen        = {isMobile}
        {...rest}
      >

        <div className={classNames.body}>

          {this.renderChannels()}

          <Subaccounts
            onBlur={this.saveSA.bind(this)}
            onChange={this.handleChangeSubaccounts.bind(this)}
            value={subaccounts ?? this.state.subaccounts}
          />

          {this.isContentDefault() ? this.renderDefaultLinkArea() : children}

        </div>

        { showMore ? (
          <ExportPopupFooter />
        ) : undefined }
      </Dialog>
    );
  }

};
